//
// jQuery UI datePicker for browsers that don't support input type='date'
//

var InitCustomDatePicker = (function () {
    'use strict';

    var jqueryDatePicker = document.querySelectorAll('#DateOfBirth');
    var formDatePicker = document.querySelectorAll('.js-datePicker');
    var formDateDropdowns = document.querySelectorAll('.js-dateDropdown');

    function init(jqueryDatePicker) {
        $(jqueryDatePicker).datepicker({
            dateFormat: 'dd/mm/yy',
            changeMonth: true,
            changeYear: true,
            yearRange: '1900:+nn',
            showOn: "both",
            buttonText: "<i class='far fa-calendar-alt'></i>"
        }).attr('type', 'text');

        $('.ui-datepicker-trigger').addClass('btn').attr('aria-label', 'Open DatePicker');
    }

    if (jqueryDatePicker.length) {
        init(jqueryDatePicker);
    }
    if (formDatePicker.length) {
        init(formDatePicker);

        $(document).ready(function () {

            $(formDatePicker).on('input blur', function () {
                try {
                    var dateParse = $.datepicker.parseDate("dd/mm/yy", $(this).val());
                    $(this).closest('form').find('[data-sf-btn-role="next"]').attr('disabled', false);
                } catch (e) {
                    // show the error message
                    var errorMessageId = $(this).attr("aria-describedby");
                    $(`#${errorMessageId}`).show();
                    $(`#${errorMessageId}`).text("Invalid Date entered");
                    $(this).closest('form').find('[data-sf-btn-role="next"]').attr('disabled', 'disabled');
                }
            });
        });
    }

    if (formDateDropdowns.length) {
        var currentYear = new Date().getFullYear(),
            currentMonth = new Date().getMonth() + 1,
            currentDay = new Date().getDate();

        $(".js-dateDropdown").dateDropdowns({
            minAge: 18,
            dropdownClass: "custom-select form-control",
            displayFormat: 'ymd',
            daySuffixes: false,
            defaultDateFormat: "dd/mm/yyyy",
            submitFormat: "dd/mm/yyyy",
            required: true,
            submitFieldTitle: "Date of birth"
        });

        $(".date-dropdowns").each(function () {
            var wrp = $(this),
                years = $(".custom-select.year", wrp),
                months = $(".custom-select.month", wrp),
                days = $(".custom-select.day", wrp),
                currentYear = new Date().getFullYear(),
                currentMonth = new Date().getMonth() + 1,
                currentDay = new Date().getDate(),
                target = wrp.find(".js-dateDropdown"),
                targetId = "#" + target.attr("aria-describedby"),
                targetMsg = $(targetId),
                maxDate = new Date((currentYear - 18) + "/" + currentMonth + "/" + currentDay);

            $(this).closest('div[data-sf-role="separator"]').find('button').on('hover focus', function () {
                var targetVal = target.val().split("/"),
                    definedDate = new Date(targetVal[2] + "/" + targetVal[1] + "/" + targetVal[0]);
                if (definedDate > maxDate) {
                    target.val("");
                    years.find("optitargetValon:selected").prop("selected", false);
                    years.find("option:disabled").prop("disabled", false);
                    months.find("option:selected").prop("selected", false);
                    months.find("option:disabled").prop("disabled", false);
                    days.find("option:selected").prop("selected", false);
                    days.prop("disabled", false);
                }
            });
            $(this).on('focusin', function () {
                targetMsg.removeClass("d-none").addClass("d-none");
            });
            $(this).on('focusout', function () {
                setTimeout(function () {
                    if (!$('.date-dropdowns').find("[name='" + document.activeElement.name + "']").length) {
                        targetMsg.removeClass("d-none");
                    }
                }, 300);
            });

            years.on("change", function () {
                if ($(this).find("option:selected").index() == 1) {
                    if (months.find("option:selected").index() > 0 || days.find("option:selected").index() > 0) {
                        $(this).nextAll(':lt(2)').find("option:selected").prop("selected", false);
                        $(this).nextAll(':lt(2)').find("option:disabled").prop("disabled", false);
                    }
                    months.find("option").each(function () {
                        if ($(this).val() > currentMonth) {
                            $(this).attr("disabled", true);
                        }
                    });
                    days.find("option").each(function () {
                        if ($(this).val() > currentDay) {
                            $(this).attr("disabled", true);
                        }
                    });
                }
                else {
                    $(this).nextAll(':lt(2)').find("option:disabled").prop("disabled", false);
                }
            });
            months.on("change", function () {
                if (years.find("option:selected").index() == 1 && currentMonth == months.find("option:selected").val()) {
                    days.find("option").each(function () {
                        if ($(this).val() > currentDay) {
                            $(this).attr("disabled", true);
                        }
                    });
                }
                else {
                    days.find("option:disabled").prop("disabled", false);
                }
            });
        });

        $(".custom-select").each(function () {
            var attrVal = $(this).attr('aria-describedby');
            if (attrVal == null || attrVal == 'undefined' | attrVal.length == 0) {
                $(this).attr('aria-describedby', 'dropdown-instructions');
            } else {
                $(this).attr('aria-describedby', attrVal + ' dropdown-instructions');
            }
        });
    }
})();
